// extracted by mini-css-extract-plugin
export var container = "_8l-0";
export var error = "_8l-9";
export var label = "_8l-5";
export var light = "_8l-6";
export var md = "_8l-3";
export var sm = "_8l-2";
export var thin = "_8l-8";
export var thinBold = "_8l-7";
export var vertical = "_8l-4";
export var xs = "_8l-1";